import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'react-bootstrap';

import Profile from '../../../container/Client/CandidateProfile/Profile';
import profileexpand from '../../../assets/images/resize.png';
import axios from '../../../services/axios-service';
/**
* @desc candidate profile view in expand mode
* @version 1.0.1
* @author Lakshmikanth
*/
class ProfilePage extends Component {  
	/**
  * @desc Actual rendering of the component
  * @param null
  * @return DOM element
  */
  render() {
		const candidate_id =this.props.match.params.id;
   return (
      <div className="profile-page">    
		  	<LinkContainer to="/">
		  		<Button bsSize="large" className="profile-resize">
					  <img className="resize" src={profileexpand}/>
					</Button>
				</LinkContainer>
    		<Profile  handlePoolUnSuitableChange={this.handlePoolUnSuitableChange} handlePoolSuitableChange={this.handlePoolSuitableChange} id={candidate_id}/>
    	</div>
    )
  }
}
/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/

const mapStateToProps = state => {
  return {
    profileInfo: state.candidateProfile.profileInfo
  };
}

export default connect(mapStateToProps, null)(ProfilePage,axios);


// WEBPACK FOOTER //
// ./src/components/Client/CandidateProfilePage/ProfilePage.js